"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePartnerBilling = exports.getPartnerPaymentType = exports.isSpecialPartner = exports.PORTAL_PARTNER_ID = exports.LOADSURE_PARTNER_ID = exports.ePrimaryBusinessType = exports.eFreightIdDuplicationCheck = exports.eLeadSourceType = exports.ePartnerType = exports.isSandboxPartner = exports.sandboxPartnerIdPrefixes = void 0;
const payments_1 = require("../payments");
const partner_class_1 = __importDefault(require("./partner.class"));
const sandboxPartnerIdPrefixes = () => ["LS-DEMO", "DEMO", "SANDBOX-"];
exports.sandboxPartnerIdPrefixes = sandboxPartnerIdPrefixes;
const isSandboxPartner = (partnerId) => exports.sandboxPartnerIdPrefixes().some((prefix) => partnerId.startsWith(prefix));
exports.isSandboxPartner = isSandboxPartner;
var ePartnerType;
(function (ePartnerType) {
    ePartnerType["PORTAL"] = "PORTAL";
    ePartnerType["WHOLESALER"] = "WHOLESALER";
    ePartnerType["RETAILER"] = "RETAILER";
    ePartnerType["ASSURED"] = "ASSURED";
})(ePartnerType = exports.ePartnerType || (exports.ePartnerType = {}));
var eLeadSourceType;
(function (eLeadSourceType) {
    eLeadSourceType["TARGETED_AD"] = "targeted_ad";
    eLeadSourceType["PUBLIC_FLOW"] = "public_flow";
    eLeadSourceType["MANUAL_PORTAL"] = "manual_portal";
    eLeadSourceType["REFERRAL"] = "referral";
    eLeadSourceType["OTHER"] = "other";
})(eLeadSourceType = exports.eLeadSourceType || (exports.eLeadSourceType = {}));
var eFreightIdDuplicationCheck;
(function (eFreightIdDuplicationCheck) {
    eFreightIdDuplicationCheck["partner"] = "partner";
    eFreightIdDuplicationCheck["user"] = "user";
})(eFreightIdDuplicationCheck = exports.eFreightIdDuplicationCheck || (exports.eFreightIdDuplicationCheck = {}));
var ePrimaryBusinessType;
(function (ePrimaryBusinessType) {
    ePrimaryBusinessType["CARRIER"] = "Carrier";
    ePrimaryBusinessType["FREIGHT_BROKER"] = "Freight Broker";
    ePrimaryBusinessType["FREIGHT_FORWARDER"] = "Freight Forwarder";
    ePrimaryBusinessType["IMPORTER_EXPORTER"] = "Importer/Exporter";
    ePrimaryBusinessType["MANUFACTURER"] = "Manufacturer";
    ePrimaryBusinessType["NVOCC"] = "NVOCC";
    ePrimaryBusinessType["SHIPPER"] = "Shipper";
    ePrimaryBusinessType["CONSTRUCTION"] = "Construction";
    ePrimaryBusinessType["THIRD_PARTY_LOGISTICS"] = "3PL";
    ePrimaryBusinessType["NOT_APPLICABLE"] = "N/A";
})(ePrimaryBusinessType = exports.ePrimaryBusinessType || (exports.ePrimaryBusinessType = {}));
exports.LOADSURE_PARTNER_ID = "@LOADSURE";
exports.PORTAL_PARTNER_ID = "@PORTAL";
function isSpecialPartner(partnerId) {
    return partnerId === null || partnerId === void 0 ? void 0 : partnerId.startsWith("@");
}
exports.isSpecialPartner = isSpecialPartner;
const getPartnerPaymentType = (partner) => {
    if (partner.payByInvoice) {
        return payments_1.ePaymentType.INVOICE;
    }
    return payments_1.ePaymentType.CREDIT_CARD;
};
exports.getPartnerPaymentType = getPartnerPaymentType;
const validatePartnerBilling = (partner, paymentMethod) => {
    const partnerPaymentType = exports.getPartnerPaymentType(partner);
    if (paymentMethod instanceof payments_1.CCPaymentMethod &&
        partnerPaymentType !== payments_1.ePaymentType.CREDIT_CARD) {
        return `Invalid payment type, this must be ${partnerPaymentType}`;
    }
    return undefined;
};
exports.validatePartnerBilling = validatePartnerBilling;
exports.default = partner_class_1.default;
//# sourceMappingURL=index.js.map